import { atom } from "jotai";
import { DeductionDocumentUploadResponse } from "@/core/repositories/deduction";

export interface DeductionUploadDocument {
  processId: number;
  file: File;
  isPending: boolean;
  isUploading: boolean;
  isUploaded: boolean;
  error: string | null;
  remittanceItemId?: number;
  type: {
    label: string;
    value: string;
  } | null;
  response: DeductionDocumentUploadResponse | null;
}

export interface DocumentUploadState {
  isDocumentUploadOpen: boolean;
  selectedModalId: number | null;
  documents: DeductionUploadDocument[];
  isAttaching: boolean;
}

const initialState: DocumentUploadState = {
  isDocumentUploadOpen: false,
  selectedModalId: null,
  documents: [],
  isAttaching: false,
};

// Base atoms
export const documentUploadAtom = atom<DocumentUploadState>(initialState);

// Derived atoms for specific states
export const isDocumentUploadOpenAtom = atom(get => get(documentUploadAtom).isDocumentUploadOpen);
export const documentsAtom = atom(get => get(documentUploadAtom).documents);
export const isAttachingAtom = atom(get => get(documentUploadAtom).isAttaching);
export const selectedModalIdAtom = atom(get => get(documentUploadAtom).selectedModalId);
